export const PerformanceMonitor = {
    metrics: new Map(),
    startTime: performance.now(),

    log(metric, value) {
        this.metrics.set(metric, value);
        if (process.env.NODE_ENV === "development") {
            console.log(`[Performance] ${metric}: ${value}`);
        }
    },

    getMetrics() {
        return Object.fromEntries(this.metrics);
    }
}